function Header() {
  const toggle = document.querySelector(".c-header-navigation__toggle");
  const navigation = document.getElementById("mobile-navigation");
  const page = document.querySelector("main");
  const headerWrapper = document.querySelector(".c-header__wrapper");

  if (!toggle || !navigation) return;

  let lastFocusedElement = null;
  let removeFocusTrap = null;

  const BREAKPOINT = 880;
  const mediaQuery = window.matchMedia(`(min-width: ${BREAKPOINT}px)`);

  const focusableSelectors = `
    a[href],
    button:not([disabled]),
    select:not([disabled]),
    input:not([disabled]),
    textarea:not([disabled]),
    [tabindex]:not([tabindex="-1"])
  `;

  /* ---------------------------------------------
   * Header height → CSS variable
   * --------------------------------------------- */
  function setHeaderHeightVar() {
    if (!headerWrapper) return;

    const height = headerWrapper.offsetHeight;
    document.documentElement.style.setProperty(
      "--header-height",
      `${height}px`,
    );
  }

  setHeaderHeightVar();
  window.addEventListener("resize", setHeaderHeightVar);

  // ---------------------------------------------
  // Initial state sync (ARIA + hidden)
  // ---------------------------------------------
  closeNavigation({ restoreFocus: false });

  /* ---------------------------------------------
   * Focus trap
   * --------------------------------------------- */
  function trapFocus(container) {
    const focusable = Array.from(
      container.querySelectorAll(focusableSelectors),
    );
    if (!focusable.length) return () => {};

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    function onKeydown(e) {
      if (e.key === "Tab") {
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      if (e.key === "Escape") {
        closeNavigation();
      }
    }

    container.addEventListener("keydown", onKeydown);
    return () => container.removeEventListener("keydown", onKeydown);
  }

  /* ---------------------------------------------
   * Navigation controls
   * --------------------------------------------- */
  function openNavigation() {
    document.body.classList.add("u-no-scroll");

    lastFocusedElement = document.activeElement;

    toggle.setAttribute("aria-expanded", "true");
    toggle.setAttribute(
      "aria-label",
      toggle.dataset.labelClose || "Close navigation",
    );

    navigation.hidden = false;
    navigation.classList.add("is-open");

    page?.setAttribute("inert", "");

    const firstFocusable = navigation.querySelector(focusableSelectors);
    firstFocusable?.focus();

    removeFocusTrap = trapFocus(navigation);
  }

  function closeNavigation() {
    document.body.classList.remove("u-no-scroll");

    toggle.setAttribute("aria-expanded", "false");
    toggle.setAttribute(
      "aria-label",
      toggle.dataset.labelOpen || "Open navigation",
    );

    navigation.classList.remove("is-open");

    setTimeout(() => {
      navigation.hidden = true;
    }, 300);

    page?.removeAttribute("inert");

    removeFocusTrap?.();
    lastFocusedElement?.focus();
  }

  /* ---------------------------------------------
   * Toggle click
   * --------------------------------------------- */
  toggle.addEventListener("click", () => {
    const isOpen = toggle.getAttribute("aria-expanded") === "true";
    isOpen ? closeNavigation() : openNavigation();
  });

  /* ---------------------------------------------
   * Close navigation on breakpoint change
   * --------------------------------------------- */
  function handleBreakpointChange(e) {
    if (e.matches && toggle.getAttribute("aria-expanded") === "true") {
      closeNavigation();
    }
  }

  mediaQuery.addEventListener("change", handleBreakpointChange);
}

export default Header;
